import React from 'react';
import styled from 'styled-components';

import { useTranslations } from '@lang';
import { filterNullElements } from '@common/adapters/spaDayAdapter';
import { RHFExtras } from '@common/components/SpaEntity/components/RHFExtras';
import Alert, { AlertTypes } from '@common/components/Alert/Alert';
import { useFormContext, useWatch } from 'react-hook-form';
import { SpaEntityFormValues } from '@common/components/SpaEntity/SpaEntityForm.schema';

const SelectFollowingOptionTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 11px;
  background: ${({ theme }) => theme.customColors.header};
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  border-radius: 4px;
`;

const ItemsWrapper = styled.div`
  padding: 20px 0 20px 20px;
`;

const getSelectedOptions = (singleGroup) => Object.values(singleGroup.treatments).flat().length;

type SelectionGroupsV2Props = {
  selectionGroups?: any[];
  selectedGuests: any[];
};

export const SelectionGroups = ({
  selectionGroups = [],
  selectedGuests,
}: SelectionGroupsV2Props) => {
  const { t } = useTranslations();
  const { formState } = useFormContext<SpaEntityFormValues>();
  const selectedGroupsValue = useWatch({ name: 'selectionGroups' });

  return (
    <>
      {selectionGroups.map((selectionGroup) => {
        const singleGroup = selectedGroupsValue?.[`group-${selectionGroup.id}`];

        const selectedOptions = singleGroup
          ? getSelectedOptions({ treatments: filterNullElements(singleGroup.treatments) })
          : 0;

        const groupError = formState.errors?.selectionGroups?.[`group-${selectionGroup.id}`];
        const isSubmitted = formState.isSubmitted;

        const numberOfGuests = selectedGuests.length;
        const numberOfRequiredSelections = selectionGroup.required * numberOfGuests;

        return (
          <div key={selectionGroup.id}>
            <SelectFollowingOptionTitleRow>
              <p>
                {t('treatment.selectFollowingOptions', {
                  action: <b>{t('treatment.selectAmount', { amount: selectionGroup.required })}</b>,
                })}
              </p>
              {t('treatment.optionsSelected', {
                selected: selectedOptions,
                required: numberOfRequiredSelections,
              })}
            </SelectFollowingOptionTitleRow>
            {isSubmitted && groupError && (
              <Alert
                type={AlertTypes.Error}
                content={t('treatment.pleaseSelectFollowingOptions', {
                  action: <b>{t('treatment.selectAmount', { amount: selectionGroup.required })}</b>,
                })}
              />
            )}
            <ItemsWrapper>
              <RHFExtras
                fieldPrefix={`selectionGroups.group-${selectionGroup.id}.treatments`}
                extras={selectionGroup.treatments}
                selectedGuests={selectedGuests}
              />
            </ItemsWrapper>
            <ItemsWrapper>
              <RHFExtras
                fieldPrefix={`selectionGroups.group-${selectionGroup.id}.classes`}
                extras={selectionGroup.classes ?? []}
                selectedGuests={selectedGuests}
              />
            </ItemsWrapper>
          </div>
        );
      })}
    </>
  );
};
